import { useCallback } from 'react';
import { TrackingApi } from 'src/api';
import { LearningSessionTrackingAction } from 'src/api/tracking/types';
import { useUserContext } from 'src/context/user';
import { BLOB_TRACKING_DATA } from '../../BlobSession/tracking';

export const useLocalProfileTracking = (languagePairId: number, actorId: number) => {
  const { user } = useUserContext();
  const isPro = !!user?.isPro;

  return useCallback(
    (action: LearningSessionTrackingAction, trackingData: Record<string, string> = {}) => {
      void TrackingApi.trackUserAction(action, 'learning_session', languagePairId, isPro, {
        ...BLOB_TRACKING_DATA,
        actor_id: String(actorId),
        ...trackingData,
      });
    },
    [languagePairId, actorId, isPro],
  );
};
